import { any, prop } from 'ramda';

const hasExtraUnrequiredFields = (form) => {
  // Check if the customer has at least one email or phone number when these fields are not required
  const hasCustomerEmails = any(prop('value'), form.watch('customer.emails') || []);
  const hasCustomerPhones = any(prop('number'), form.watch('customer.phones') || []);

  return hasCustomerEmails || hasCustomerPhones;
};

export default hasExtraUnrequiredFields;
